/**
 * Seamly Channel API
 * The API for Seamly Channel REST API
 *
 * NOTE: This class is generated by bsp-share-codegen-angular OpenAPI Generator.
 * https://bitbucket.verz.local:8443/projects/AP-CLI/repos/apcli-devolksbank-codegen/browse
 *
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigResponse } from '@fp/interfaces/conversational/generated/model/config-response';
import { GetAccountConfigRequest } from '@fp/interfaces/conversational/generated/model/get-account-config-request';
import { TranslationsResponse } from '../model/translations-response';

import { BASE_PATH } from '../variables';

export interface GetAccountConfigRequestParams {
    /** Seamly account API key */
    apiKey: string;
    /** Payload */
    getAccountConfigRequest?: GetAccountConfigRequest;
}

export interface GetAccountTranslationsRequestParams {
    /** Seamly account API key */
    apiKey: string;
    /** Translation file version */
    version: number;
    /** Locale to get translations for */
    locale: string;
}

@Injectable()
export class AccountService {
    public defaultHeaders = new HttpHeaders();
    protected basePath: string;

    constructor(
        protected httpClient: HttpClient,
        @Inject(BASE_PATH) basePath: string
    ) {
        this.basePath = basePath;
    }

    /**
     * Get account settings and conversation defaults
     *
     * @param requestParameters
     */
    public getAccountConfig(
        requestParameters: GetAccountConfigRequestParams,
        options?: { httpHeaderAccept?: 'application/json' }
    ): Observable<ConfigResponse> {
        const apiKey = requestParameters.apiKey;
        if (apiKey === null || apiKey === undefined) {
            throw new Error('Required parameter apiKey was null or undefined when calling getAccountConfig.');
        }
        const getAccountConfigRequest = requestParameters.getAccountConfigRequest;

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['application/json'];
            httpHeaderAcceptSelected = httpHeaderAccepts[0];
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        headers = headers.set('Content-Type', 'application/json');

        let responseType: 'text' | 'json' | 'blob' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.endsWith('pdf')) {
            responseType = 'blob';
        }

        return this.httpClient.post<ConfigResponse>(
            `${this.basePath}/channels/api/v2/client/${encodeURIComponent(String(apiKey))}/configs`,
            getAccountConfigRequest,
            {
                responseType: responseType as any,
                headers
            }
        );
    }

    /**
     * @param requestParameters
     */
    public getAccountTranslations(
        requestParameters: GetAccountTranslationsRequestParams,
        options?: { httpHeaderAccept?: 'application/json' | 'plain/text' }
    ): Observable<TranslationsResponse> {
        const apiKey = requestParameters.apiKey;
        if (apiKey === null || apiKey === undefined) {
            throw new Error('Required parameter apiKey was null or undefined when calling getAccountTranslations.');
        }
        const version = requestParameters.version;
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling getAccountTranslations.');
        }
        const locale = requestParameters.locale;
        if (locale === null || locale === undefined) {
            throw new Error('Required parameter locale was null or undefined when calling getAccountTranslations.');
        }

        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['application/json', 'plain/text'];
            httpHeaderAcceptSelected = httpHeaderAccepts[0];
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        let responseType: 'text' | 'json' | 'blob' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.endsWith('pdf')) {
            responseType = 'blob';
        }

        return this.httpClient.get<TranslationsResponse>(
            `${this.basePath}/channels/api/v2/client/${encodeURIComponent(String(apiKey))}/translations/${encodeURIComponent(String(version))}/${encodeURIComponent(String(locale))}.json`,
            {
                responseType: responseType as any,
                headers
            }
        );
    }
}
